//copy icons from _fontello.scss paste in excel
//Find :* replace blank
//Find . replace blank to remove the dots
//paste column into https://shancarter.github.io/mr-data-converter/
//select JSON - Column Arrays

export const Icons = [
  { name: "icon-glass", label: "icon-glass" },
  { name: "icon-dot-3", label: "icon-dot-3" },
  { name: "icon-lock", label: "icon-lock" },
  { name: "icon-lock-open", label: "icon-lock-open" },
  { name: "icon-ok", label: "icon-ok" },
  { name: "icon-undo", label: "icon-undo" },
  { name: "icon-attention-circled", label: "icon-attention-circled" },
  { name: "icon-mobile", label: "icon-mobile" },
  { name: "icon-key", label: "icon-key" },
  { name: "icon-eye", label: "icon-eye" },
  { name: "icon-eye-off", label: "icon-eye-off" },
  { name: "icon-cancel", label: "icon-cancel" },
  { name: "icon-user", label: "icon-user" },
  { name: "icon-left", label: "icon-left" },
  { name: "icon-book", label: "icon-book" },
  { name: "icon-globe", label: "icon-globe" },
  { name: "icon-info-circled", label: "icon-info-circled" },
  { name: "icon-ok-circled", label: "icon-ok-circled" },
  { name: "icon-attention", label: "icon-attention" },
  { name: "icon-right", label: "icon-right" },
  { name: "icon-print", label: "icon-print" },
  { name: "icon-pencil", label: "icon-pencil" },
  { name: "icon-edit", label: "icon-edit" },
  { name: "icon-wrench", label: "icon-wrench" },
  { name: "icon-basket", label: "icon-basket" },
  { name: "icon-logout", label: "icon-logout" },
  { name: "icon-clipboard", label: "icon-clipboard" },
  { name: "icon-forward", label: "icon-forward" },
  { name: "icon-music", label: "icon-music" },
  { name: "icon-search", label: "icon-search" },
  { name: "icon-mail", label: "icon-mail" },
  { name: "icon-heart", label: "icon-heart" },
  { name: "icon-heart-empty", label: "icon-heart-empty" },
  { name: "icon-star", label: "icon-star" },
  { name: "icon-star-empty", label: "icon-star-empty" },
  { name: "icon-star-half", label: "icon-star-half" },
  { name: "icon-user-1", label: "icon-user-alt" },
  { name: "icon-users", label: "icon-users" },
  { name: "icon-video", label: "icon-video" },
  { name: "icon-videocam", label: "icon-videocam" },
  { name: "icon-picture", label: "icon-picture" },
  { name: "icon-cloud-outline", label: "icon-cloud-outline" },
  { name: "icon-camera", label: "icon-camera" },
  { name: "icon-plus", label: "icon-plus" },
  { name: "icon-times-light", label: "icon-times-light" },
  { name: "icon-alert", label: "icon-alert" },
  { name: "icon-team-gear", label: "icon-team-gear" },
  { name: "icon-user-gear", label: "icon-user-gear" },
  { name: "icon-camera-alt", label: "icon-camera-alt" },
  { name: "icon-th-large", label: "icon-table-large" },
  { name: "icon-th", label: "icon-table" },
  { name: "icon-th-list", label: "icon-table-list" },
  { name: "icon-company", label: "icon-company" },
  { name: "icon-company-solid", label: "icon-company-solid" },
  { name: "icon-individual", label: "icon-individual" },
  { name: "icon-ok-circled2", label: "icon-ok-circled2" },
  { name: "icon-cancel-1", label: "icon-cancel-1" },
  { name: "icon-cancel-circled", label: "icon-cancel-circled" },
  { name: "icon-cancel-circled2", label: "icon-cancel-circled2" },
  { name: "icon-plus-1", label: "icon-plus-1" },
  { name: "icon-plus-circled", label: "icon-plus-circled" },
  { name: "icon-minus", label: "icon-minus" },
  { name: "icon-minus-circled", label: "icon-minus-circled" },
  { name: "icon-help-circled", label: "icon-help-circled" },
  { name: "icon-home", label: "icon-home" },
  { name: "icon-link", label: "icon-link" },
  { name: "icon-attach", label: "icon-attach" },
  { name: "icon-pin", label: "icon-pin" },
  { name: "icon-tag", label: "icon-tag" },
  { name: "icon-tags", label: "icon-tags" },
  { name: "icon-bookmark", label: "icon-bookmark" },
  { name: "icon-flag", label: "icon-flag" },
  { name: "icon-thumbs-up", label: "icon-thumbs-up" },
  { name: "icon-thumbs-down", label: "icon-thumbs-down" },
  { name: "icon-download", label: "icon-download" },
  { name: "icon-upload", label: "icon-upload" },
  { name: "icon-export", label: "icon-export" },
  { name: "icon-retweet", label: "icon-retweet" },
  { name: "icon-comment", label: "icon-comment" },
  { name: "icon-chat", label: "icon-chat" },
  { name: "icon-bell", label: "icon-bell" },
  { name: "icon-location", label: "icon-location" },
  { name: "icon-trash-empty", label: "icon-trash-empty" },
  { name: "icon-doc", label: "icon-doc" },
  { name: "icon-folder", label: "icon-folder" },
  { name: "icon-folder-open", label: "icon-folder-open" },
  { name: "icon-phone", label: "icon-phone" },
  { name: "icon-cog", label: "icon-cog" },
  { name: "icon-cog-alt", label: "icon-cog-alt" },
  { name: "icon-calendar", label: "icon-calendar" },
  { name: "icon-login", label: "icon-login" },
  { name: "icon-volume-off", label: "icon-volume-off" },
  { name: "icon-volume-down", label: "icon-volume-down" },
  { name: "icon-volume-up", label: "icon-volume-up" },
  { name: "icon-headphones", label: "icon-headphones" },
  { name: "icon-clock", label: "icon-clock" },
  { name: "icon-block", label: "icon-block" },
  { name: "icon-resize-full", label: "icon-resize-full" },
  { name: "icon-resize-small", label: "icon-resize-small" },
  { name: "icon-down-dir", label: "icon-down-dir" },
  { name: "icon-up-dir", label: "icon-up-dir" },
  { name: "icon-resize-vertical", label: "icon-resize-vertical" },
  { name: "icon-resize-horizontal", label: "icon-resize-horizontal" },
  { name: "icon-zoom-in", label: "icon-zoom-in" },
  { name: "icon-zoom-out", label: "icon-zoom-out" },
  { name: "icon-down-circled2", label: "icon-down-circle-reverse" },
  { name: "icon-up-circled2", label: "icon-up-circle-reverse" },
  { name: "icon-left-dir", label: "icon-left-dir" },
  { name: "icon-right-dir", label: "icon-right-dir" },
  { name: "icon-down-open", label: "icon-down-open" },
  { name: "icon-left-open", label: "icon-left-open" },
  { name: "icon-right-open", label: "icon-right-open" },
  { name: "icon-up-open", label: "icon-up-open" },
  { name: "icon-down-big", label: "icon-down-big" },
  { name: "icon-left-big", label: "icon-left-big" },
  { name: "icon-right-big", label: "icon-right-big" },
  { name: "icon-up-big", label: "icon-up-big" },
  { name: "icon-right-hand", label: "icon-right-hand" },
  { name: "icon-left-hand", label: "icon-left-hand" },
  { name: "icon-up-hand", label: "icon-up-hand" },
  { name: "icon-down-hand", label: "icon-down-hand" },
  { name: "icon-cw", label: "icon-cw" },
  { name: "icon-ccw", label: "icon-ccw" },
  { name: "icon-arrows-cw", label: "icon-arrows-cw" },
  { name: "icon-shuffle", label: "icon-shuffle" },
  { name: "icon-play", label: "icon-play" },
  { name: "icon-play-circled2", label: "icon-play-circled-reverse" },
  { name: "icon-stop", label: "icon-stop" },
  { name: "icon-pause", label: "icon-pause" },
  { name: "icon-to-end", label: "icon-to-end" },
  { name: "icon-to-end-alt", label: "icon-to-end-alt" },
  { name: "icon-to-start", label: "icon-to-start" },
  { name: "icon-to-start-alt", label: "icon-to-start-alt" },
  { name: "icon-fast-fw", label: "icon-fast-fw" },
  { name: "icon-fast-bw", label: "icon-fast-bw" },
  { name: "icon-eject", label: "icon-eject" },
  { name: "icon-target", label: "icon-target" },
  { name: "icon-signal", label: "icon-signal" },
  { name: "icon-award", label: "icon-award" },
  { name: "icon-inbox", label: "icon-inbox" },
  { name: "icon-cloud", label: "icon-cloud" },
  { name: "icon-flash", label: "icon-flash" },
  { name: "icon-umbrella", label: "icon-umbrella" },
  { name: "icon-flight", label: "icon-flight" },
  { name: "icon-leaf", label: "icon-leaf" },
  { name: "icon-font", label: "icon-font" },
  { name: "icon-bold", label: "icon-bold" },
  { name: "icon-italic", label: "icon-italic" },
  { name: "icon-text-height", label: "icon-text-height" },
  { name: "icon-text-width", label: "icon-text-width" },
  { name: "icon-align-left", label: "icon-align-left" },
  { name: "icon-align-center", label: "icon-align-center" },
  { name: "icon-align-right", label: "icon-align-right" },
  { name: "icon-align-justify", label: "icon-align-justify" },
  { name: "icon-list", label: "icon-list" },
  { name: "icon-indent-left", label: "icon-indent-left" },
  { name: "icon-indent-right", label: "icon-indent-right" },
  { name: "icon-scissors", label: "icon-scissors" },
  { name: "icon-briefcase", label: "icon-briefcase" },
  { name: "icon-off", label: "icon-off" },
  { name: "icon-road", label: "icon-road" },
  { name: "icon-list-alt", label: "icon-list-alt" },
  { name: "icon-qrcode", label: "icon-qrcode" },
  { name: "icon-barcode", label: "icon-barcode" },
  { name: "icon-adjust", label: "icon-adjust" },
  { name: "icon-tint", label: "icon-tint" },
  { name: "icon-check", label: "icon-check" },
  { name: "icon-asterisk", label: "icon-asterisk" },
  { name: "icon-gift", label: "icon-gift" },
  { name: "icon-fire", label: "icon-fire" },
  { name: "icon-magnet", label: "icon-magnet" },
  { name: "icon-chart-bar", label: "icon-chart-bar" },
  { name: "icon-credit-card", label: "icon-credit-card" },
  { name: "icon-floppy", label: "icon-floppy" },
  { name: "icon-megaphone", label: "icon-megaphone" },
  { name: "icon-key-1", label: "icon-key-mortice" },
  { name: "icon-truck", label: "icon-truck" },
  { name: "icon-hammer", label: "icon-hammer" },
  { name: "icon-move", label: "icon-move" },
  { name: "icon-link-ext", label: "icon-link-ext" },
  { name: "icon-check-empty", label: "icon-check-empty" },
  { name: "icon-bookmark-empty", label: "icon-bookmark-empty" },
  { name: "icon-phone-squared", label: "icon-phone-squared" },
  { name: "icon-twitter", label: "icon-twitter" },
  { name: "icon-facebook", label: "icon-facebook" },
  { name: "icon-github-circled", label: "icon-github-circled" },
  { name: "icon-rss", label: "icon-rss" },
  { name: "icon-hdd", label: "icon-hdd" },
  { name: "icon-certificate", label: "icon-certificate" },
  { name: "icon-left-circled", label: "icon-left-circled" },
  { name: "icon-right-circled", label: "icon-right-circled" },
  { name: "icon-up-circled", label: "icon-up-circled" },
  { name: "icon-down-circled", label: "icon-down-circled" },
  { name: "icon-tasks", label: "icon-tasks" },
  { name: "icon-filter", label: "icon-filter" },
  { name: "icon-resize-full-alt", label: "icon-resize-full-alt" },
  { name: "icon-beaker", label: "icon-beaker" },
  { name: "icon-docs", label: "icon-docs" },
  { name: "icon-blank", label: "icon-blank" },
  { name: "icon-menu", label: "icon-menu" },
  { name: "icon-list-bullet", label: "icon-list-bullet" },
  { name: "icon-list-numbered", label: "icon-list-numbered" },
  { name: "icon-table", label: "icon-table" },
  { name: "icon-magic", label: "icon-magic" },
  { name: "icon-pinterest-circled", label: "icon-pinterest-circled" },
  { name: "icon-pinterest-squared", label: "icon-pinterest-squared" },
  { name: "icon-money", label: "icon-money" },
  { name: "icon-columns", label: "icon-columns" },
  { name: "icon-sort", label: "icon-sort" },
  { name: "icon-sort-down", label: "icon-sort-down" },
  { name: "icon-sort-up", label: "icon-sort-up" },
  { name: "icon-mail-alt", label: "icon-mail-alt" },
  { name: "icon-linkedin", label: "icon-linkedin" },
  { name: "icon-gauge", label: "icon-gauge" },
  { name: "icon-comment-empty", label: "icon-comment-empty" },
  { name: "icon-chat-empty", label: "icon-chat-empty" },
  { name: "icon-sitemap", label: "icon-sitemap" },
  { name: "icon-paste", label: "icon-paste" },
  { name: "icon-lightbulb", label: "icon-lightbulb" },
  { name: "icon-exchange", label: "icon-exchange" },
  { name: "icon-download-cloud", label: "icon-download-cloud" },
  { name: "icon-upload-cloud", label: "icon-upload-cloud" },
  { name: "icon-user-md", label: "icon-user-md" },
  { name: "icon-stethoscope", label: "icon-stethoscope" },
  { name: "icon-suitcase", label: "icon-suitcase" },
  { name: "icon-bell-alt", label: "icon-bell-alt" },
  { name: "icon-food", label: "icon-food" },
  { name: "icon-doc-text", label: "icon-doc-text" },
  { name: "icon-building", label: "icon-building" },
  { name: "icon-hospital", label: "icon-hospital" },
  { name: "icon-ambulance", label: "icon-ambulance" },
  { name: "icon-medkit", label: "icon-medical-kit" },
  { name: "icon-fighter-jet", label: "icon-fighter-jet" },
  { name: "icon-beer", label: "icon-beer" },
  { name: "icon-h-sigh", label: "icon-hospital-sign" },
  { name: "icon-plus-squared", label: "icon-plus-squared" },
  { name: "icon-angle-double-left", label: "icon-angle-double-left" },
  { name: "icon-angle-double-right", label: "icon-angle-double-right" },
  { name: "icon-angle-double-up", label: "icon-angle-double-up" },
  { name: "icon-angle-double-down", label: "icon-angle-double-down" },
  { name: "icon-angle-left", label: "icon-angle-left" },
  { name: "icon-angle-right", label: "icon-angle-right" },
  { name: "icon-angle-up", label: "icon-angle-up" },
  { name: "icon-angle-down", label: "icon-angle-down" },
  { name: "icon-desktop", label: "icon-desktop" },
  { name: "icon-laptop", label: "icon-laptop" },
  { name: "icon-tablet", label: "icon-tablet" },
  { name: "icon-mobile-1", label: "icon-mobile-small" },
  { name: "icon-circle-empty", label: "icon-circle-empty" },
  { name: "icon-quote-left", label: "icon-quote-left" },
  { name: "icon-quote-right", label: "icon-quote-right" },
  { name: "icon-spinner", label: "icon-spinner" },
  { name: "icon-circle", label: "icon-circle" },
  { name: "icon-reply", label: "icon-reply" },
  { name: "icon-folder-empty", label: "icon-folder-empty" },
  { name: "icon-folder-open-empty", label: "icon-folder-open-empty" },
  { name: "icon-smile", label: "icon-smile" },
  { name: "icon-frown", label: "icon-frown" },
  { name: "icon-meh", label: "icon-meh" },
  { name: "icon-keyboard", label: "icon-keyboard" },
  { name: "icon-terminal", label: "icon-terminal" },
  { name: "icon-code", label: "icon-code" },
  { name: "icon-reply-all", label: "icon-reply-all" },
  { name: "icon-star-half-alt", label: "icon-star-half-alt" },
  { name: "icon-direction", label: "icon-direction" },
  { name: "icon-crop", label: "icon-crop" },
  { name: "icon-unlink", label: "icon-unlink" },
  { name: "icon-help", label: "icon-help" },
  { name: "icon-info", label: "icon-info" },
  { name: "icon-attention-alt", label: "icon-attention-alt" },
  { name: "icon-eraser", label: "icon-eraser" },
  { name: "icon-mic", label: "icon-mic" },
  { name: "icon-mute", label: "icon-mute" },
  { name: "icon-shield", label: "icon-shield" },
  { name: "icon-calendar-empty", label: "icon-calendar-empty" },
  { name: "icon-rocket", label: "icon-rocket" },
  { name: "icon-angle-circled-left", label: "icon-angle-circled-left" },
  { name: "icon-angle-circled-right", label: "icon-angle-circled-right" },
  { name: "icon-angle-circled-up", label: "icon-angle-circled-up" },
  { name: "icon-angle-circled-down", label: "icon-angle-circled-down" },
  { name: "icon-anchor", label: "icon-anchor" },
  { name: "icon-lock-open-alt", label: "icon-lock-open-alt" },
  { name: "icon-bullseye", label: "icon-bullseye" },
  { name: "icon-ellipsis", label: "icon-ellipsis" },
  { name: "icon-ellipsis-vert", label: "icon-ellipsis-vert" },
  { name: "icon-rss-squared", label: "icon-rss-squared" },
  { name: "icon-play-circled", label: "icon-play-circled" },
  { name: "icon-minus-squared", label: "icon-minus-squared" },
  { name: "icon-minus-squared-alt", label: "icon-minus-squared-alt" },
  { name: "icon-level-up", label: "icon-level-up" },
  { name: "icon-level-down", label: "icon-level-down" },
  { name: "icon-ok-squared", label: "icon-ok-squared" },
  { name: "icon-pencil-squared", label: "icon-pencil-squared" },
  { name: "icon-link-ext-alt", label: "icon-link-ext-alt" },
  { name: "icon-export-alt", label: "icon-export-alt" },
  { name: "icon-compass", label: "icon-compass" },
  { name: "icon-expand", label: "icon-expand" },
  { name: "icon-collapse", label: "icon-collapse" },
  { name: "icon-expand-right", label: "icon-expand-right" },
  { name: "icon-euro", label: "icon-euro" },
  { name: "icon-pound", label: "icon-pound" },
  { name: "icon-dollar", label: "icon-dollar" },
  { name: "icon-rupee", label: "icon-rupee" },
  { name: "icon-yen", label: "icon-yen" },
  { name: "icon-rouble", label: "icon-rouble" },
  { name: "icon-won", label: "icon-won" },
  { name: "icon-bitcoin", label: "icon-bitcoin" },
  { name: "icon-doc-inv", label: "icon-doc-inv" },
  { name: "icon-doc-text-inv", label: "icon-doc-text-inv" },
  { name: "icon-sort-name-up", label: "icon-sort-name-up" },
  { name: "icon-sort-name-down", label: "icon-sort-name-down" },
  { name: "icon-sort-alt-up", label: "icon-sort-alt-up" },
  { name: "icon-sort-alt-down", label: "icon-sort-alt-down" },
  { name: "icon-sort-number-up", label: "icon-sort-number-up" },
  { name: "icon-sort-number-down", label: "icon-sort-number-down" },
  { name: "icon-thumbs-up-alt", label: "icon-thumbs-up-alt" },
  { name: "icon-thumbs-down-alt", label: "icon-thumbs-down-alt" },
  { name: "icon-bitbucket", label: "icon-bitbucket" },
  { name: "icon-bitbucket-squared", label: "icon-bitbucket-squared" },
  { name: "icon-down", label: "icon-down" },
  { name: "icon-up", label: "icon-up" },
  { name: "icon-left-1", label: "icon-left-small" },
  { name: "icon-right-1", label: "icon-right-small" },
  { name: "icon-gittip", label: "icon-gittip" },
  { name: "icon-sun", label: "icon-sun" },
  { name: "icon-moon", label: "icon-moon" },
  { name: "icon-box", label: "icon-box" },
  { name: "icon-bug", label: "icon-bug" },
  { name: "icon-stackexchange", label: "icon-stackexchange" },
  { name: "icon-right-circled2", label: "icon-right-circled2" },
  { name: "icon-left-circled2", label: "icon-left-circled2" },
  { name: "icon-collapse-left", label: "icon-collapse-left" },
  { name: "icon-dot-circled", label: "icon-dot-circled" },
  { name: "icon-plus-squared-alt", label: "icon-plus-squared-alt" },
  { name: "icon-mail-squared", label: "icon-mail-squared" },
  { name: "icon-bank", label: "icon-bank" },
  { name: "icon-graduation-cap", label: "icon-graduation-cap" },
  { name: "icon-fax", label: "icon-fax" },
  { name: "icon-building-filled", label: "icon-building-filled" },
  { name: "icon-child", label: "icon-child" },
  { name: "icon-cube", label: "icon-cube" },
  { name: "icon-cubes", label: "icon-cubes" },
  { name: "icon-spotify", label: "icon-spotify" },
  { name: "icon-soundcloud", label: "icon-soundcloud" },
  { name: "icon-database", label: "icon-database" },
  { name: "icon-file-pdf", label: "icon-file-pdf" },
  { name: "icon-file-word", label: "icon-file-word" },
  { name: "icon-file-excel", label: "icon-file-excel" },
  { name: "icon-file-powerpoint", label: "icon-file-powerpoint" },
  { name: "icon-file-image", label: "icon-file-image" },
  { name: "icon-file-archive", label: "icon-file-archive" },
  { name: "icon-file-audio", label: "icon-file-audio" },
  { name: "icon-file-video", label: "icon-file-video" },
  { name: "icon-file-code", label: "icon-file-code" },
  { name: "icon-codeopen", label: "icon-codeopen" },
  { name: "icon-lifebuoy", label: "icon-lifebuoy" },
  { name: "icon-circle-notch", label: "icon-circle-notch" },
  { name: "icon-wechat", label: "icon-wechat" },
  { name: "icon-paper-plane", label: "icon-paper-plane" },
  { name: "icon-paper-plane-empty", label: "icon-paper-plane-empty" },
  { name: "icon-history", label: "icon-history" },
  { name: "icon-circle-thin", label: "icon-circle-thin" },
  { name: "icon-paragraph", label: "icon-paragraph" },
  { name: "icon-sliders", label: "icon-sliders" },
  { name: "icon-share", label: "icon-share" },
  { name: "icon-share-squared", label: "icon-share-squared" },
  { name: "icon-bomb", label: "icon-bomb" },
  { name: "icon-tty", label: "icon-tty" },
  { name: "icon-binoculars", label: "icon-binoculars" },
  { name: "icon-plug", label: "icon-plug" },
  { name: "icon-newspaper", label: "icon-newspaper" },
  { name: "icon-wifi", label: "icon-wifi" },
  { name: "icon-calc", label: "icon-calculator" },
  { name: "icon-cc-visa", label: "icon-cc-visa" },
  { name: "icon-cc-mastercard", label: "icon-cc-mastercard" },
  { name: "icon-cc-discover", label: "icon-cc-discover" },
  { name: "icon-cc-amex", label: "icon-cc-amex" },
  { name: "icon-cc-paypal", label: "icon-cc-paypal" },
  { name: "icon-cc-stripe", label: "icon-cc-stripe" },
  { name: "icon-bell-off", label: "icon-bell-off" },
  { name: "icon-bell-off-empty", label: "icon-bell-off-empty" },
  { name: "icon-trash", label: "icon-trash" },
  { name: "icon-copyright", label: "icon-copyright" },
  { name: "icon-at", label: "icon-at" },
  { name: "icon-eyedropper", label: "icon-eyedropper" },
  { name: "icon-brush", label: "icon-brush" },
  { name: "icon-chart-area", label: "icon-chart-area" },
  { name: "icon-chart-pie", label: "icon-chart-pie" },
  { name: "icon-chart-line", label: "icon-chart-line" },
  { name: "icon-toggle-off", label: "icon-toggle-off" },
  { name: "icon-toggle-on", label: "icon-toggle-on" },
  { name: "icon-bicycle", label: "icon-bicycle" },
  { name: "icon-bus", label: "icon-bus" },
  { name: "icon-ioxhost", label: "icon-ioxhost" },
  { name: "icon-angellist", label: "icon-angellist" },
  { name: "icon-cc", label: "icon-cc" },
  { name: "icon-leanpub", label: "icon-leanpub" },
  { name: "icon-sellsy", label: "icon-sellsy" },
  { name: "icon-cart-plus", label: "icon-cart-plus" },
  { name: "icon-cart-arrow-down", label: "icon-cart-arrow-down" },
  { name: "icon-user-secret", label: "icon-user-secret" },
  { name: "icon-street-view", label: "icon-street-view" },
  { name: "icon-heartbeat", label: "icon-heartbeat" },
  { name: "icon-neuter", label: "icon-neuter" },
  { name: "icon-genderless", label: "icon-genderless" },
  { name: "icon-facebook-official", label: "icon-facebook-official" },
  { name: "icon-whatsapp", label: "icon-whatsapp" },
  { name: "icon-server", label: "icon-server" },
  { name: "icon-user-plus", label: "icon-user-plus" },
  { name: "icon-user-times", label: "icon-user-times" },
  { name: "icon-expeditedssl", label: "icon-expeditedssl" },
  { name: "icon-battery-0", label: "icon-battery-0" },
  { name: "icon-mouse-pointer", label: "icon-mouse-pointer" },
  { name: "icon-i-cursor", label: "icon-i-cursor" },
  { name: "icon-object-group", label: "icon-object-group" },
  { name: "icon-object-ungroup", label: "icon-object-ungroup" },
  { name: "icon-sticky-note", label: "icon-sticky-note" },
  { name: "icon-sticky-note-o", label: "icon-sticky-note-o" },
  { name: "icon-cc-jcb", label: "icon-cc-jcb" },
  { name: "icon-cc-diners-club", label: "icon-cc-diners-club" },
  { name: "icon-clone", label: "icon-clone" },
  { name: "icon-balance-scale", label: "icon-balance-scale" },
  { name: "icon-hourglass-o", label: "icon-hourglass-o" },
  { name: "icon-hourglass-1", label: "icon-hourglass-1" },
  { name: "icon-hourglass-2", label: "icon-hourglass-2" },
  { name: "icon-hourglass-3", label: "icon-hourglass-3" },
  { name: "icon-hourglass", label: "icon-hourglass" },
  { name: "icon-hand-grab-o", label: "icon-hand-grab-o" },
  { name: "icon-hand-paper-o", label: "icon-hand-paper-o" },
  { name: "icon-hand-scissors-o", label: "icon-hand-scissors-o" },
  { name: "icon-hand-lizard-o", label: "icon-hand-lizard-o" },
  { name: "icon-hand-spock-o", label: "icon-hand-spock-o" },
  { name: "icon-hand-pointer-o", label: "icon-hand-pointer-o" },
  { name: "icon-hand-peace-o", label: "icon-hand-peace-o" },
  { name: "icon-odnoklassniki", label: "icon-odnoklassniki" },
  { name: "icon-odnoklassniki-square", label: "icon-odnoklassniki-square" },
  { name: "icon-get-pocket", label: "icon-get-pocket" },
  { name: "icon-wikipedia-w", label: "icon-wikipedia-w" },
  { name: "icon-television", label: "icon-television" },
  { name: "icon-calendar-plus-o", label: "icon-calendar-plus-o" },
  { name: "icon-calendar-minus-o", label: "icon-calendar-minus-o" },
  { name: "icon-calendar-times-o", label: "icon-calendar-times-o" },
  { name: "icon-calendar-check-o", label: "icon-calendar-check-o" },
  { name: "icon-industry", label: "icon-industry" },
  { name: "icon-map-pin", label: "icon-map-pin" },
  { name: "icon-map-signs", label: "icon-map-signs" },
  { name: "icon-map-o", label: "icon-map-o" },
  { name: "icon-map", label: "icon-map" },
  { name: "icon-commenting", label: "icon-commenting" },
  { name: "icon-commenting-o", label: "icon-commenting-o" },
  { name: "icon-black-tie", label: "icon-black-tie" },
  { name: "icon-edge", label: "icon-edge" },
  { name: "icon-credit-card-alt", label: "icon-credit-card-alt" },
  { name: "icon-fort-awesome", label: "icon-fort-awesome" },
  { name: "icon-usb", label: "icon-usb" },
  { name: "icon-product-hunt", label: "icon-product-hunt" },
  { name: "icon-mixcloud", label: "icon-mixcloud" },
  { name: "icon-pause-circle", label: "icon-pause-circle" },
  { name: "icon-pause-circle-o", label: "icon-pause-circle-o" },
  { name: "icon-stop-circle", label: "icon-stop-circle" },
  { name: "icon-stop-circle-o", label: "icon-stop-circle-o" },
  { name: "icon-shopping-bag", label: "icon-shopping-bag" },
  { name: "icon-shopping-basket", label: "icon-shopping-basket" },
  { name: "icon-hashtag", label: "icon-hashtag" },
  { name: "icon-percent", label: "icon-percent" },
  { name: "icon-wpforms", label: "icon-wpforms" },
  { name: "icon-envira", label: "icon-envira" },
  { name: "icon-universal-access", label: "icon-universal-access" },
  { name: "icon-wheelchair-alt", label: "icon-wheelchair-alt" },
  { name: "icon-question-circle-o", label: "icon-question-circle-o" },
  { name: "icon-blind", label: "icon-blind" },
  { name: "icon-volume-control-phone", label: "icon-volume-control-phone" },
  { name: "icon-sign-language", label: "icon-sign-language" },
  { name: "icon-low-vision", label: "icon-low-vision" },
  { name: "icon-viadeo-square", label: "icon-viadeo-square" },
  { name: "icon-font-awesome", label: "icon-font-awesome" },
  { name: "icon-handshake-o", label: "icon-handshake-o" },
  { name: "icon-envelope-open", label: "icon-envelope-open" },
  { name: "icon-envelope-open-o", label: "icon-envelope-open-o" },
  { name: "icon-address-book", label: "icon-address-book" },
  { name: "icon-address-book-o", label: "icon-address-book-o" },
  { name: "icon-address-card", label: "icon-address-card" },
  { name: "icon-address-card-o", label: "icon-address-card-o" },
  { name: "icon-user-circle", label: "icon-user-circle" },
  { name: "icon-user-circle-o", label: "icon-user-circle-o" },
  { name: "icon-user-o", label: "icon-user-o" },
  { name: "icon-id-badge", label: "icon-id-badge" },
  { name: "icon-id-card", label: "icon-id-card" },
  { name: "icon-id-card-o", label: "icon-id-card-o" },
  { name: "icon-telegram", label: "icon-telegram" },
  { name: "icon-thermometer-0", label: "icon-thermometer-0" },
  { name: "icon-podcast", label: "icon-podcast" },
  { name: "icon-window-maximize", label: "icon-window-maximize" },
  { name: "icon-window-minimize", label: "icon-window-minimize" },
  { name: "icon-window-restore", label: "icon-window-restore" },
  { name: "icon-window-close", label: "icon-window-close" },
  { name: "icon-window-close-o", label: "icon-window-close-o" },
  { name: "icon-microchip", label: "icon-microchip" },
  { name: "icon-snowflake-o", label: "icon-snowflake-o" },
  { name: "icon-twitter-squared", label: "icon-twitter-squared" },
  { name: "icon-facebook-squared", label: "icon-facebook-squared" },
  { name: "icon-linkedin-squared", label: "icon-linkedin-squared" },
  { name: "icon-ccard", label: "icon-ccard" },
  { name: "icon-coins", label: "icon-coins" },
  { name: "icon-wallet", label: "icon-wallet" },
  { name: "icon-angle-up-o", label: "icon-angle-up-o" },
  { name: "icon-angle-down-o", label: "icon-angle-down-o" },
  { name: "icon-angle-left-o", label: "icon-angle-left-o" },
  { name: "icon-angle-right-o", label: "icon-angle-right-o" },
  { name: "icon-ok-bookmark-solid", label: "icon-ok-bookmark-solid" },
  { name: "icon-binoculars-1", label: "icon-binoculars-1" },
  { name: "icon-check-thin", label: "icon-check-thin" },
  { name: "icon-user-circle-2", label: "icon-user-circle-2" },
  { name: "icon-users-circle-2", label: "icon-users-circle-2" },
  { name: "icon-user-option", label: "icon-user-option" },
  { name: "icon-users-option", label: "icon-users-option" },
  { name: "icon-pre-paid", label: "icon-pre-paid" },
  { name: "icon-bank-1", label: "icon-bank-1" },
  { name: "icon-credit-card-1", label: "icon-credit-card-1" },
  { name: "icon-direct-debit", label: "icon-direct-debit" },
  { name: "icon-invoice", label: "icon-invoice" },
  { name: "icon-check-circle", label: "icon-check-circle" },
  { name: "icon-checklist", label: "icon-checklist" },
  { name: "icon-blank", label: "icon-blank" }
];
